/* Selector de variantes de la landing. Sin dependencias.
   Mantiene la página como fuente de la verdad: actualiza el precio, el botón,
   la imagen, todos los input[name="id"] de la página y el ?variant= de la URL,
   que es de donde los formularios de contra entrega leen la variante. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lp-vars]');
  if (!root) return;

  var data;
  try {
    data = JSON.parse(root.querySelector('[data-lp-vars-data]').textContent);
  } catch (e) { return; }

  var grupos = root.querySelectorAll('[data-lp-opt]');
  var recargar = root.getAttribute('data-recargar') === '1';
  var galeria = document.querySelector('.lp__img');
  var origen = galeria
    ? { src: galeria.getAttribute('src'), set: galeria.getAttribute('srcset') }
    : null;

  function elegidas() {
    var out = [];
    for (var i = 0; i < grupos.length; i++) {
      var on = grupos[i].querySelector('.lp__var-in:checked');
      out.push(on ? on.value : null);
    }
    return out;
  }

  function buscar(sel) {
    for (var i = 0; i < data.length; i++) {
      var igual = true;
      for (var j = 0; j < sel.length; j++) {
        if (data[i].o[j] !== sel[j]) { igual = false; break; }
      }
      if (igual) return data[i];
    }
    return null;
  }

  function aplicar(v) {
    var precio = document.querySelector('[data-lp-price]');
    if (precio) precio.textContent = v.pf;

    var antes = document.querySelector('[data-lp-compare]');
    var off = document.querySelector('[data-lp-off]');
    var rebaja = v.c > v.p;

    if (antes) { antes.textContent = v.cf; antes.hidden = !rebaja; }
    if (off) {
      off.hidden = !rebaja;
      if (rebaja) {
        var pct = Math.round((v.c - v.p) * 100 / v.c);
        off.textContent = (off.getAttribute('data-lp-off-tpl') || '').replace('[descuento]', pct);
      }
    }

    var ids = document.querySelectorAll('input[name="id"]');
    for (var i = 0; i < ids.length; i++) ids[i].value = v.id;

    var cta = document.querySelector('.lp__cta');
    if (cta) cta.disabled = !v.a;

    for (var k = 0; k < grupos.length; k++) {
      var et = grupos[k].querySelector('[data-lp-sel]');
      if (et) et.textContent = v.o[k];
    }

    if (galeria) {
      if (v.iu) {
        galeria.setAttribute('src', v.iu);
        galeria.removeAttribute('srcset');
      } else if (origen && origen.src) {
        galeria.setAttribute('src', origen.src);
        if (origen.set) galeria.setAttribute('srcset', origen.set);
      }
    }

    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    } catch (e) {}

    document.dispatchEvent(new CustomEvent('lp:variante', { detail: v }));
  }

  root.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('lp__var-in')) return;
    var v = buscar(elegidas());
    if (!v) return;

    if (recargar) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        location.href = u.toString();
      } catch (err) {
        location.href = '?variant=' + v.id;
      }
      return;
    }

    aplicar(v);
  });
})();
